import React, { useState, useEffect, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { clearAllAction, screenLoadingAction } from 'redux/actions'
import { registerAndLogin } from 'redux/reducers/apiReducers/registerReducer'
import { logoutAction } from 'redux/reducers/apiReducers/authenticationReducer'
import axios from 'axios'
import moment from 'moment'

const PrivacyNoticeView = ({ t, i18n, setIsError }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [errMsg] = useState('')
  const [outageRichText, setOutageRichText] = useState(null)
  const [outageStartDate, setOutageStartDate] = useState('')
  const [outageEndDate, setOutageEndDate] = useState('')
  const dateNow = moment().toDate()
  const outageUrl = window.location.origin + '/services/outageservice/api/outage-events'
  const outageServiceUrl = window.location.origin + '/services/outageservice/api/selected-services'
  const [serviceFlag, setServiceFlag] = useState(false)
  const [dateFlag, setDateFlag] = useState(false)
  const [outageActive, setOutageActive] = useState(false)
  const [disableFlag, setDisableFlag] = useState(false)
  const [warningStartDate, setWarningStartDate] = useState('')
  const [warningEndDate, setWarningEndDate] = useState('')
  const [warningRichText, setWarningRichText] = useState(null)
  const [warningFlag, setWarningFlag] = useState(false)
  const warningServiceUrl = window.location.origin + '/services/outageservice/api/warning-message-services'
  const [warningServiceFlag, setWarningServiceFlag] = useState(false)
  const warnEventUrl = window.location.origin + '/services/outageservice/api/warning-events'

  const sendGetRequest = async () => {
    try {
      const res = await axios.get(outageUrl)
      const json = res.data
      let index = json.length - 1
      setOutageStartDate(json[String(index)].outageStart)
      setOutageEndDate(json[String(index)].outageEnd)
      setOutageRichText(json[String(index)].outageRichText)
      setOutageActive(json[String(index)].outageActive)
    } catch (err) {
      // Handle Error Here
      console.error(err)
    }
  }

  const sendWarnGetRequest = async () => {
    try {
      const res = await axios.get(warnEventUrl)
      const json = res.data
      let index = json.length - 1
      setWarningStartDate(json[String(index)].warningStartDate)
      setWarningEndDate(json[String(index)].warningEndDate)
      setWarningRichText(json[String(index)].warningMessageText)
    } catch (err) {
      // Handle Error Here
      console.error(err)
    }
  }

  const sendServiceGetRequest = async () => {
    try {
      //axios get request
      const res = await axios.get(outageServiceUrl)
      const json = res.data
      json.map((a) => {
        if (a.serviceType === 'PAYACOLLECTIONDEBT' || a.serviceType === 'ALLSERVICES') {
          setServiceFlag(true)
          // console.log('serviceFlag true')
        }
      })
    } catch (err) {
      // Handle Error Here
      console.error(err)
    }
  }

  const sendWarningServiceGetRequest = async () => {
    try {
      const res = await axios.get(warningServiceUrl)
      const json = res.data
      json.map((a) => {
        if (a.serviceType === 'PAYACOLLECTIONDEBT' || a.serviceType === 'ALLSERVICES') {
          setWarningServiceFlag(true)
          // console.log('serviceFlag true')
        }
      })
    } catch (err) {
      // Handle Error Here
      console.error(err)
    }
  }

  useEffect(() => {
    sendGetRequest()
    sendWarnGetRequest()
    sendServiceGetRequest()
    sendWarningServiceGetRequest()
  }, [])

  const momentOutageStartDate = moment(outageStartDate).toDate()
  const momentOutageEndDate = moment(outageEndDate).toDate()
  const momentWarningStartDate = moment(warningStartDate).toDate()
  const momentWarningEndDate = moment(warningEndDate).toDate()
  // console.log(momentOutageStartDate)
  // console.log(momentOutageEndDate)
  useEffect(() => {
    if (dateNow > momentOutageStartDate && dateNow < momentOutageEndDate) {
      setDateFlag(true)
    }
  }, [momentOutageStartDate, momentOutageEndDate])

  useEffect(() => {
    if (dateNow > momentWarningStartDate && dateNow < momentWarningEndDate) {
      setWarningFlag(true)
    }
  }, [momentWarningStartDate, momentWarningEndDate])

  useEffect(() => {
    if (dateFlag && serviceFlag && outageActive) {
      // flag = true
      setDisableFlag(true)
      // console.log(flag)
    }
  }, [dateFlag, serviceFlag, outageActive])

  useEffect(() => {
    try {
      dispatch(clearAllAction())
      dispatch(logoutAction()).catch((e) => {
        console.log(e)
      })
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [dispatch, setIsError])

  const checkCookiesEnabled = () => {
    try {
      var cookieEnabled = navigator.cookieEnabled
      if (!cookieEnabled) {
        document.cookie = 'testcookie'
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1
        if (cookieEnabled) {
          return true
        } else {
          setIsError('privacy_notice.enable_cookies')
        }
      }
      return cookieEnabled
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const privacyNext = async () => {
    try {
      if (checkCookiesEnabled()) {
        dispatch(screenLoadingAction())
        dispatch(registerAndLogin())
          .then(() => {
            history.push(`/${i18n.language}${t('routes.screening_question')}`)
            dispatch(screenLoadingAction())
          })
          .catch((e) => {
            dispatch(screenLoadingAction())
            console.log(e)
            setIsError('privacy_notice.server_error')
          })
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const foipop = useMemo(() => {
    return i18n.language === 'en' ? t('privacy_notice.para1_foipop') : <i lang="en">{t('privacy_notice.para1_foipop')}</i>
  }, [t, i18n.language])

  const foipopAbbr = useMemo(() => {
    return i18n.language === 'en' ? t('privacy_notice.para1_foipop_abbr') : <i lang="en">{t('privacy_notice.para1_foipop_abbr')}</i>
  }, [t, i18n.language])

  let richTextMessage
  if (disableFlag === true) {
    richTextMessage = <div>{outageRichText}</div>
  }

  let warningRichTextMessage
  //set warning richTextMessage here if current date is between warning start and end date
  if (warningFlag === true) {
    warningRichTextMessage = <div>{warningRichText}</div>
  }

  function Banner() {
    if (disableFlag === true) {
      return (
        <div
          className="alert-medium"
          data-gtm-vis-first-on-screen-9622674_25="908"
          data-gtm-vis-total-visible-time-9622674_25="100"
          data-gtm-vis-has-fired-9622674_25="1"
          data-gtm-vis-first-on-screen-9622674_29="912"
          data-gtm-vis-total-visible-time-9622674_29="100"
          data-gtm-vis-has-fired-9622674_29="1"
        >
          <p className="no-margin">
            <span>{richTextMessage}</span>
          </p>
        </div>
      )
    }
    return null
  }

  function WarningBanner() {
    if (warningFlag === true && disableFlag === false && warningServiceFlag === true) {
      return (
        <div
          className="alert-medium"
          data-gtm-vis-first-on-screen-9622674_25="908"
          data-gtm-vis-total-visible-time-9622674_25="100"
          data-gtm-vis-has-fired-9622674_25="1"
          data-gtm-vis-first-on-screen-9622674_29="912"
          data-gtm-vis-total-visible-time-9622674_29="100"
          data-gtm-vis-has-fired-9622674_29="1"
        >
          <p className="no-margin">
            <span>{warningRichTextMessage}</span>
          </p>
        </div>
      )
    }
    return null
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <h1>{t('title')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <Banner />
          <WarningBanner />
          <h2>{t('privacy_notice.page_title')}</h2>
          <p>
            {t('privacy_notice.para1')}
            {foipop}
            {foipopAbbr}
            {t('privacy_notice.para1_foipop_cont')}
          </p>
          <p>{t('privacy_notice.para1_other')}</p>
          <p>
            {t('privacy_notice.para2')}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={
                i18n.language === 'en' ? 'https://beta.novascotia.ca/privacy' : 'https://beta.novascotia.ca/fr/enonce-de-confidentialite'
              }
            >
              {' '}
              {t('privacy_notice.privacy_statement_link')}
              <span className="ns-visually-hidden">{t('shared.opens_in_new_tab')}</span>
            </a>
            {t('privacy_notice.para2_cont')}.{t('privacy_notice.para3')}
            <a href="mailto:askus@novascotia.ca">{t('privacy_notice.ask_novascotia')}</a>.
          </p>
        </div>
      </div>
      <div className="form-group has-error">
        <button
          disabled={disableFlag}
          className="btn-lg btn-default"
          style={{ marginBottom: errMsg === '' ? '' : '5px' }}
          onClick={privacyNext}
          value={t('privacy_notice.continue')}
          name={t('privacy_notice.continue')}
        >
          {t('privacy_notice.continue')}
        </button>{' '}
        {errMsg === '' ? '' : <i aria-label={t('shared.error')} className="fa fa-exclamation-circle" aria-hidden="true" />}
        <div className="help-block">{t(errMsg)}</div>
      </div>
    </div>
  )
}

export default withTranslation('common')(PrivacyNoticeView)
